module.exports = __webpack_public_path__ + "files/7518e52c0079fd022f8ce5332a5539e3.png";


//////////////////
// WEBPACK FOOTER
// ./images/googleLogo.png
// module id = 1156
// module chunks = 76